module.exports = __webpack_public_path__ + "b5be291b062f488b518e1ce4b8535f3f.svg";